"use client";
import { cn } from "@/lib/utils";

export default function PlayButton({ variant = "play", className }) {
  if (variant === "arrow") {
    return (
      <div
        className={cn(
          "relative flex w-[108px] h-[108px] items-center justify-center group transition-all duration-300", // removed 'cursor-pointer'
          className
        )}
      >
        {/* Main SVG with white border and inverted corners */}
        <svg
          viewBox="0 0 108 108"
          xmlns="http://www.w3.org/2000/svg"
          className="absolute inset-0 w-full h-full"
        >
          {/* Thick white border as outer rounded rectangle */}
          <rect x="0" y="0" width="109" height="108" rx="31" fill="white" />
          {/* Blue inner rounded rectangle for button face */}
          <rect x="7" y="7" width="94" height="94" rx="26" fill="#3A599C" />
        </svg>

        {/* Small curve - bottom-left */}
        <div className="absolute right-15 -top-12">
          <svg
            className="w-15 h-10 rotate-90"
            viewBox="0 0 80 56"
            fill="white"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M80 56V0C80 42 48 56 0 56H80Z" />
          </svg>
        </div>
        <div className="absolute right-12 -top-0">
          <svg
            className="w-16 h-10 rotate-180"
            viewBox="0 0 80 56"
            fill="white"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M80 56V0C80 42 48 56 0 56H80Z" />
          </svg>
        </div>
        

        {/* Large curve - top-right */}
        <div className="absolute bottom-2 left-24">
          <svg
            className="w-15 h-10 rotate-90"
            viewBox="0 0 80 56"
            fill="white"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M80 56V0C80 42 48 56 0 56H80Z" />
          </svg>
        </div>
        <div className="absolute bottom-0 left-12">
          <svg
            className="w-15 h-10 rotate-360"
            viewBox="0 0 80 56"
            fill="white"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M80 56V0C80 42 48 56 0 56H80Z" />
          </svg>
        </div>

        {/* Up-right arrow icon */}
        <svg
          width="42"
          height="42"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="relative z-10 w-10 h-10 transform group-hover:scale-110 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-200"
        >
          <path
            d="M12 36L36 12M36 12H16M36 12V32"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    );
  }

}
